import React, { useState, useEffect, createRef, useRef } from 'react';
import { compose, } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { useJsApiLoader } from "@react-google-maps/api";
import CloseableDialogTitle from 'components/layout/CloseableDialogTitle';
import { BulkCreatePropMasterLocation } from 'api/revue/import';
import { appNotify } from 'store/actions';
import { GoogleMap, Marker } from "@react-google-maps/api";
import { format } from 'date-fns';
import YellowMarker from "assets/images/rex/yellow-dot.png";
import RedMarker from "assets/images/rex/red-dot.png";
import { LoadingOverlayWrapper } from 'components/layout';
import { 
  BulkLocationVerificationGridColumnConfig, 
  BulkLocationVerificationButtonConfig 
} from 'components/underwrite/acquisition/import/importOpportunities/LocationVerification/BulkLocationVerificationConfig';
import {
  Divider,
  DialogContent,
  Button,
  Dialog,
  Typography,
  CircularProgress
} from '@material-ui/core';
import DataGrid, {
  Column,
  Pager,
  Paging,
  Sorting,
  Scrolling,
  ColumnFixing,
  Editing,
  KeyboardNavigation,
  Selection
} from 'devextreme-react/data-grid';
import ContextMenu from 'devextreme-react/context-menu';
import 'components/underwrite/acquisition/import/importOpportunities/LocationVerification/BulkLocationVerificationModal.css';
import { validateLatAndLong } from 'api/revue/import';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { googleMapsApiKey } from "index";

const scriptLibraries = ['geometry', 'places'];
const US_CENTER_LAT = 37.0902;
const US_CENTER_LNG = -95.7129;

const BulkLocationVerificationModal = ({geoValidationDto, classes, open, onClose, disableBackdropClick, 
                                        bulkUpdateLocation, appNotify, appSettings, setConfirmationModalState}) => {
  const gridRef = createRef();
  const contextMenuRef = createRef();
  const map = useRef(null);
  const [pmCreateIsLoading, setPmCreateIsLoading] = useState(false);
  const [isLatLngValidationLoading, setIsLatLngValidationLoading] = useState(false);
  const [mapInitialized, setMapInitialized] = useState(false);
  const [mapShowinAllPins, setMapShowinAllPins] = useState(true);
  const [createPropDisable, setCreatePropDisable] = useState(false);
  const [savetoImportGrid, setSavetoImportGrid] = useState(false);
  const [createMode, setCreateMode] = useState(geoValidationDto.some(r => !r.geoResultDto.propertyMasterResult.asgPropID));
  const [currentProp, setCurrentProp] = useState(null);
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey,
    libraries: scriptLibraries
  });
  const [propertyMasterResult, setPropertyMasterResult] = useState([]);

  const init = async () => {
    return setPropertyMasterResult(await addIsLatLngValidToPropertyMasterResult(geoValidationDto.map(row => {
      const pmResultBkp = row.geoResultDto.propertyMasterResultBkp;
      const pmResult = row.geoResultDto.propertyMasterResult;
      return {
        referenceId: row.referenceId,
        sourceId: row.sourceId,
        city: row.city,
        street: row.street,
        state: row.state,
        latitude: pmResult.latitude == null ? row.latitude : pmResult.latitude,
        longitude: pmResult.longitude == null ? row.longitude : pmResult.longitude,
        zipCode: row.zipCode,
        status: pmResult.status,
        propUnitID: pmResult.propUnitID,
        asgPropID: pmResult.asgPropID,
        hasUnits: pmResult.hasUnits,
        geoCodedBy: pmResult.geoCodedBy,
        geocodeMatchQuality: pmResult.geocodeMatchQuality,
        provider: pmResult.provider,
        propCreated: pmResult.asgPropID ? true : false,
        pmLatitude: pmResultBkp?.latitude,
        pmLongitude: pmResultBkp?.longitude,
        pmCity: pmResultBkp?.city,
        pmStreet: pmResultBkp?.cleanAddress,
        pmState: pmResultBkp?.state,
        pmZipCode: pmResultBkp?.zip,
        county: pmResult.county,
        nearMatchesCount: pmResult.nearMatches?.length,
        message: '',
        propSelectedOnMap: false,
      };
    }), true))
  }

  useEffect(() => {
    init();
  }, [])
  useEffect(() => {
    if (!mapInitialized) return;
    let bound = new window.google.maps.LatLngBounds();
    const zoom = 4;
    manageButtonAvailavility()
    if ( propertyMasterResult.some(c => c.latitude != null && c.longitude != null && c?.isLatLngValid )) {
      if(mapShowinAllPins)
      {
        for(const loc of propertyMasterResult)
        {
          if(loc.latitude && loc.longitude)
          {
            bound.extend( new window.google.maps.LatLng(loc.latitude,loc.longitude) );
          }
        }
        map.current.fitBounds(bound);
        setMapShowinAllPins(false);
      }
    }else{
      setCreatePropDisable(true);
      bound.extend(new window.google.maps.LatLng(US_CENTER_LAT, US_CENTER_LNG));
      map.current.setCenter(bound.getCenter());
      map.current.setZoom(zoom);
    }
  }, [propertyMasterResult,mapInitialized]);

  useEffect(() => {
    if (!pmCreateIsLoading) return;
    setPmCreateIsLoading(false);
    setCreateMode(false);
    setCreatePropDisable(true);
    checkJitCreation();
  }, [propertyMasterResult])

  const setBestFit = () => {
    let bound = new window.google.maps.LatLngBounds();
    if ( propertyMasterResult.some(c => c.latitude != null && c.longitude != null )) {
      for(const loc of propertyMasterResult)
      {
        if(loc.latitude && loc.longitude)
        {
          bound.extend( new window.google.maps.LatLng(loc.latitude,loc.longitude) );
        }
      }
      map.current.fitBounds(bound);
    }
  }

  const manageButtonAvailavility = () => {
    let disable = true;
    if(createMode)
    {
      disable = propertyMasterResult.some(c => !c.latitude || !c.longitude || !c.street || 
                                          !c.city || !c.state || !c.zipCode || !c?.isLatLngValid);
    }
    setCreatePropDisable(disable);
  }

  const updateImportGrid = async () => {
    if (!savetoImportGrid) return;
    const newGeoValidationDto= [];
    for (const row of geoValidationDto){
      const pm = propertyMasterResult.find(x => x.referenceId === row.referenceId);
      const geoResultDto = {
        ...row.geoResultDto,
        latitude: pm.latitude,
        longitude: pm.longitude,
        state: pm.state,
        street: pm.street,
        zipCode: pm.zipCode,
        propertyMasterResult: {
          ...row.geoResultDto.propertyMasterResult,
          cleanAddress: pm.street,
          latitude: pm.latitude,
          longitude: pm.longitude,
          status: pm.status,
          asgPropID: pm.asgPropID,
          hasUnits: pm.hasUnits,
          geoCodedBy: pm.geoCodedBy,
          geocodeMatchQuality: pm.geocodeMatchQuality,
          provider: pm.provider,
        },
        locationVerificationUsed: pm.locationVerificationUsed
      }
      newGeoValidationDto.push(geoResultDto);
    }
    bulkUpdateLocation(newGeoValidationDto);
    setSavetoImportGrid(false);
  }

  const onSetMapRef = m => {
    map.current = m;
    setMapInitialized(true);
  }

  const onEditingStart = e => {
    setCreatePropDisable(true);
  }
  
  const onFocusedCellChanged = async (e) =>{
    manageButtonAvailavility()
    if(!e.row) return;
    const ref = gridRef?.current?.instance;
    if (ref && !ref.isRowSelected(e.row.key)) {
      ref.selectRows([e.row.key]);
    }
    setCurrentProp(e.row.data);
  }

  const handleContextMenuItemClick = e => {
    if (!e.itemData.items) {
        e.itemData.onItemClick();
    }
  }

  const renderContextMenuItem = (contextMenuItem, index) => {
      if (contextMenuItem.text === 'loading') {
          return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress size={16} /></div>;
      }
      else {
          return <React.Fragment>
              <span style={{ marginRight: '5px' }}>{contextMenuItem.text}</span>
              {contextMenuItem.items ? <span className="dx-icon-spinright" style={{ position: 'absolute', top: '7px', right: '2px' }} /> : null}
          </React.Fragment>;
      }
  }

  const onHiddenContextMenu = e => {
    contextMenuRef.current.instance.option({ items: [], target: '#bulkLocationVerificationGridContainer' });
  }

  const handleContextMenu = e => {
    if (e.row?.rowType === 'data') {
      const ref = gridRef.current.instance;
      if (!ref.isRowSelected(e.row.key)) {
        ref.selectRows([e.row.key]);
      }
      const selectedRows = ref.getSelectedRowsData();
      if (!selectedRows.length) return;
      e.items = [];
      showCustomContextMenu(e, ref.getSelectedRowsData());
    }
  }

  const showCustomContextMenu = (e, selectedRows) => {
    contextMenuRef.current.instance.option({ items: [{ text: "loading" }], target: e.targetElement });
    contextMenuRef.current.instance.show();
    var menuItems = getActionContextMenu(selectedRows);
    contextMenuRef.current.instance.option({ items: menuItems, showSubmenuMode: 'onHover' });
  }

  const getActionContextMenu = (selectedRows) => {
    const hasLatLng = selectedRows[0]?.latitude && selectedRows[0]?.longitude ? false : true;
    return [
        {
            text: `Zoom to Property`,
            disabled: hasLatLng,
            onItemClick: () => zoomToCurrentProp(selectedRows[0])
        }
    ];
  }

  const zoomToCurrentProp = prop =>{
    let bound = new window.google.maps.LatLngBounds();
    const zoom = 16;
    bound.extend(new window.google.maps.LatLng(prop.latitude, prop.longitude));
    map.current.setCenter(bound.getCenter());
    map.current.setZoom(zoom);
    setCurrentProp(prop);
    selectCurrentPropOnTheMap();
  }

  const highlightSelectedProp = args =>{
    selectRow(args);
    const { latLng } = args;
    const prop = propertyMasterResult.find( c => c.latitude === latLng.lat() && c.longitude === latLng.lng() );
    setCurrentProp(prop);
    selectCurrentPropOnTheMap();
  }
  
  const selectCurrentPropOnTheMap = () => {
    const updatedPMresult = propertyMasterResult.map(col => {
      if(col.referenceId === currentProp?.referenceId){
        return {
          ...col,
          propSelectedOnMap: true
        }
      }
      return {
        ...col,
        propSelectedOnMap: false
      }
    });
    setPropertyMasterResult(updatedPMresult);
  }

  const onMarkerDragStart = args => {
    highlightSelectedProp(args);
  }

  const addIsLatLngValidToPropertyMasterResult = async (propertyMasterResult, isInit) => {
      setIsLatLngValidationLoading(true);
      const arrayOfLatAndLong = propertyMasterResult.map(({ latitude, longitude }) => ({ lat: latitude, long: longitude }))
      const response = await validateLatAndLong(arrayOfLatAndLong)
      const result = propertyMasterResult.map(v => {
        let validationResult;
        if (v.latitude == null && v.longitude == null) {
          validationResult = response.find(r => r.lat == null && r.long == null); // Account for undefined v.latitude/longitude returning null r.lat/long
        } else {
          validationResult = response.find(r => v.latitude === parseFloat(r.lat) && v.longitude === parseFloat(r.long));
        }
        const obj = { ...v, isLatLngValid: validationResult.isValid, locationVerificationUsed: !isInit }
        return obj;
      })
      setIsLatLngValidationLoading(false);
      return result;
  }

  const onMarkerDragEnd = args => {
    const { latLng } = args;
    currentProp.latitude = latLng.lat();
    currentProp.longitude = latLng.lng();
    addIsLatLngValidToPropertyMasterResult([currentProp]).then(validatedProperties => {
      const validatedProperty = validatedProperties[0];
      const newLocations = propertyMasterResult.map(row => { // Update grid with new location
        if (row.referenceId === currentProp.referenceId) {
          
          return validatedProperty;
        }
        return row;
      })
      setSavetoImportGrid(true);
      setPropertyMasterResult(newLocations);
    })
  }

  const onMarkerClick = args => {
    highlightSelectedProp(args);
  }

  const selectRow = args => {
    const { latLng } = args;
    const dataSource = gridRef.current.instance.getDataSource();
    const propSelected = dataSource.items().find(row => row.latitude === latLng.lat() && row.longitude === latLng.lng());
    if (!gridRef.current.instance.isRowSelected(propSelected.referenceId)) {
      gridRef.current.instance.selectRows([propSelected.referenceId]);
    }
  }

  const handleSaveEdit = (e) => {
    const gridInstance = gridRef.current.instance;
      const dataSource = gridInstance.getDataSource();
      gridInstance.getDataByKeys(e.changes.map(v => v.key)).then(rowsThatChanged => {
        addIsLatLngValidToPropertyMasterResult(rowsThatChanged).then(validatedRes => {
        gridInstance.beginUpdate();
        setTimeout(() => {
          const newPropMasterResult = dataSource.items().map(v => {
            const validatedRow = validatedRes.find(vr => vr.referenceId === v.referenceId)
            if(validatedRow) {
              v = validatedRow
            }
            return v;
          })
          saveEdit(newPropMasterResult);
        }, 100);
        gridInstance.endUpdate();
          })
        })
    }

  const saveEdit = items => {
    setMapShowinAllPins(true);
    setSavetoImportGrid(true);
    setPropertyMasterResult(items);
  }

  const handlePasteFromExcel = async e => {
    // const result = await navigator.permissions.query({ name: 'clipboard-read' });
    try {
      const data = await navigator.clipboard.readText();
      await getPastedData(data, 'bulkJitImportGrid');
    } catch (err) {
      appNotify(`Paste Error: ${JSON.stringify(err)}`, 'error');
    }
  };

  const handleExportToExcel = () => {
    const timestamp = format(new Date(), '_yyyy-MM-dd_HHmmss');
    const fileName = 'ReVUe_BulkLocationVerification' + timestamp;

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet');
    worksheet.getRow(1).height = 40;

    exportDataGrid({
      component: gridRef.current.instance,
      worksheet,
      customizeCell: ({ gridCell, excelCell }) => {
          if (gridCell.column.cssClass === 'cell-disabled') {
            excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e0e0e0' } };
        }
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
      });
    });

  }

  const getPastedData = async (data, headerType) => {
    let filteredFieldSettings = BulkLocationVerificationGridColumnConfig.filter(v => v.allowEditing !== false);
    let myEligibleHeaders = filteredFieldSettings.map(fieldObj => {
      return {
        ...fieldObj,
        fieldToLowerCase: fieldObj.caption.replace(/\s+/g, '').toLowerCase()
      }
    });
    let myData = data;
    myData =  parsePastedData(data, myEligibleHeaders);
    let foundRows = 0;
    let foundDataRows = false;
    const newPropMasterRes = propertyMasterResult.map(row => {
      const pastedRow = myData.find( r => r.sourceId === row.sourceId);
      if(pastedRow){
        foundRows = foundRows +1;
        foundDataRows = pastedRow.street || pastedRow.city || pastedRow.state || pastedRow.zipCode || pastedRow.latitude || pastedRow.longitude;
        return {
          ...row,
          street: (pastedRow.street && pastedRow.street.trim().length >0) ? pastedRow.street : row.street,
          city: (pastedRow.city && pastedRow.city.trim().length >0) ? pastedRow.city : row.city,
          state: (pastedRow.state && pastedRow.state.trim().length >0) ? pastedRow.state : row.state,
          zipCode: (pastedRow.zipCode && pastedRow.zipCode.trim().length >0) ? pastedRow.zipCode : row.zipCode,
          latitude: (pastedRow.latitude && pastedRow.latitude.trim().length >0) ? parseFloat(pastedRow.latitude) : row.latitude,
          longitude: (pastedRow.longitude && pastedRow.longitude.trim().length >0) ? parseFloat(pastedRow.longitude) : row.longitude
        }
      }
      return row;
    });
    const validatedPropMasterRes = await addIsLatLngValidToPropertyMasterResult(newPropMasterRes);
    setMapShowinAllPins(true);
    setSavetoImportGrid(true);
    setPropertyMasterResult(validatedPropMasterRes);
    if (foundRows>0){
      const message = foundDataRows ? `${foundRows} matching row(s) updated.` : 'No data rows were found';
      const messageType = foundDataRows ? 'success' : 'warning';
      appNotify(message, messageType);
    }else{
      appNotify(`No matching Source ID were found.`, 'warning');
    }
  }

  const parsePastedData = (importPastedData, eligibleHeaders) => {
    const newImportRows = [];
    const rows = importPastedData.split('\n');
    const cleanedRows = rows.filter(r => r !== '');  // Remove empty rows, this is usually the last row
    if (cleanedRows.length) {
      const editableFields = BulkLocationVerificationGridColumnConfig.filter(v => v.allowEditing !== false).map(v => v.caption)
      const headerRow = cleanedRows.shift().split('\t').map(header => header.trim()) // Shift out first row to check for headers
      .reduce((prev, curr) => { // filter non-editable and duplicate fields
        if(!prev.includes(curr) && editableFields.includes(curr)) 
          prev.push(curr)
        return prev;
      }, [])
      
      const foundAtLeastOne = headerRow.some(c => eligibleHeaders.find(el => el.fieldToLowerCase === c.replace(/\s+/g, '').toLowerCase()));

      if (foundAtLeastOne) {
        if (cleanedRows.length) { // Split remaining data rows into cells
          cleanedRows.forEach(row => {
            const cells = row.split('\t');
            const newRow = {};
            headerRow.forEach((col, index) => {
              let header = eligibleHeaders.find(el => el.fieldToLowerCase === col.replace(/\s+/g, '').toLowerCase())
              if(header){
                newRow[header.dataField] = cells[index].replace('\r','');
              }
            })
            newImportRows.push(newRow);
          });
        } else {
          appNotify('No data rows were found', 'warning');
        }
      } else {
        appNotify('No matching headers were found', 'warning');
      }
    }
    return newImportRows;
  }

  const closeConfirmationModal = () => {
    setConfirmationModalState({ isModalOpen: false });
  }

  const handleCreateProperties = () => {
    setConfirmationModalState({ 
      isModalOpen: true,
      handleConfirmation: handleSubmitCreateProperties,
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to create these ${propertyMasterResult.filter(r => !r.asgPropID).length} properties?`
    });
  }

  const handleSubmitCreateProperties = async () => {
    closeConfirmationModal();
    setPmCreateIsLoading(true);
    const savetoImportGrid = propertyMasterResult.some( x => x.asgPropID);
    setSavetoImportGrid(savetoImportGrid);
    let propCreated = [];
    const request = propertyMasterResult.filter(row => {
      if (!row.propCreated){
        return {
          referenceId: row.referenceId,
          latitude: row.latitude,
          longitude: row.longitude,
          street: row.street,
          city: row.city,
          state: row.state,
          zipCode: row.zipCode
        }
      }
    });
    if (request.length > 0 )
    {
      await BulkCreatePropMasterLocation(request).then(res => {
        propCreated = res.map(r => {
          const row = propertyMasterResult.find( p => p.referenceId === r.referenceId);
          return {
            ...r,
            referenceId: row.referenceId,
            propertyMasterResult: { // Always save user inputs instead of PM results for these fields
              ...r.propertyMasterResult,
              latitude: row.latitude,
              longitude: row.longitude,
              cleanAddress: row.street,
              city: row.city,
              state: row.state,
              zip: row.zipCode
            },
            propertyMasterResultBkp: {
                ...r.propertyMasterResult,
            },
            locationVerificationUsed: row.locationVerificationUsed
          }
        })
        if (res.some(r => !r.locationCreated)) { 
          appNotify('Unable to create property', 'warning');
        }
      }).catch(err => {
        appNotify(`An error occurred - ${err.message || err}`, 'error');
      }); 
    } 
    bulkUpdateLocation(propCreated);
    updatePMresult(propCreated);
  }

  const updatePMresult = async propertiesCreated => {
    setPropertyMasterResult(propertyMasterResult.map(pmRow => {
      const geoResultDto = propertiesCreated.find( c => c.referenceId === pmRow.referenceId);
      if(geoResultDto){
        const pmResult = geoResultDto.propertyMasterResult;
        const pmResultBkp = geoResultDto.propertyMasterResultBkp;
        return {
          ...pmRow,
          status: pmResult.status,
          asgPropID: pmResult.asgPropID,
          hasUnits: pmResult.hasUnits,
          geoCodedBy: pmResult.geoCodedBy,
          geocodeMatchQuality: pmResult.geocodeMatchQuality,
          provider: pmResult.provider,
          message:geoResultDto.locationCreated ? '': 
          `Unable to create property. PM status response: ${pmResult.status}${pmResult.asgPropID ? `. PM/asgPropID: ${pmResult.asgPropID}` : ''}`,
          propertyMasterResultBkp: pmResultBkp,
          pmLatitude: pmResultBkp.latitude,
          pmLongitude: pmResultBkp.longitude,
          pmCity: pmResultBkp.city,
          pmStreet: pmResultBkp.cleanAddress,
          pmState: pmResultBkp.state,
          pmZipCode: pmResultBkp.zip,
          county: pmResult.county,
          nearMatchesCount: pmResult.nearMatches?.length,
          propCreated: true,
        };
      }
      return pmRow;
    }));
  }

  const checkJitCreation = () => {
    if (propertyMasterResult.some(row => !row.propCreated)){
      appNotify('Something went wrong creating the properties.', 'warning');
    }else{
      if (createMode)
      {
        appNotify('Properties Created', 'success');
      }else{
        appNotify('Properties Updated', 'success');
      }
    }
  }

  const saveAndClose = () => {
    updateImportGrid();
    onClose();
  }
  
  const cellPrepared = (e) => {
    if (e.rowType === 'data' && (e.column.dataField === "latitude" || e.column.dataField === "longitude") && !e.data?.isLatLngValid) {
      e.cellElement.classList.add('invalidCell');
    }
  }

  const handleClose = (e, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') return; // updated handling for disableBackdropClick
    onClose();
  }

  if (!isLoaded) return null;
  return (
    <Dialog open={open} onClose={handleClose} maxWidth={"xl"} classes={{paper: classes.dialogPaper}}>
      <LoadingOverlayWrapper
        active={pmCreateIsLoading || isLatLngValidationLoading}
        message={isLatLngValidationLoading ? 'Validating Locations...' : pmCreateIsLoading ? 'Creating Properties...' : ''}
        className={classes.loadingOverlayWrapper}        
        background={'rgba(242, 242, 242)'}
        >
        <CloseableDialogTitle onClose={saveAndClose}>
          <Typography variant='h6'>{`Bulk Location Verification`}</Typography>
        </CloseableDialogTitle>
        <Divider />
        <div style={{position: 'relative', minHeight: 0, height: '100%'}}>
          <DialogContent style={{ height: '100%', display: 'flex', flexDirection: 'column'}}>
            <div style={{ display: 'flex'}}>
              <div style={{ display: 'flex', width:'80%', marginBottom: 8, justifyContent: 'left'}}>
                <Button
                  {...BulkLocationVerificationButtonConfig}
                  onClick={() => setBestFit()}
                >
                  Best Fit Map 
                </Button>
                <Button
                  {...BulkLocationVerificationButtonConfig}
                  onClick={() => handlePasteFromExcel()}
                >
                  Paste From Clipboard 
                </Button>
                <Button
                  {...BulkLocationVerificationButtonConfig}
                  onClick={() => handleExportToExcel()}
                >
                  Export
                </Button>
              </div>
              <div style={{ display: 'flex', width:'20%', marginBottom: 8, justifyContent: 'right'}}>
                <Button
                  {...BulkLocationVerificationButtonConfig}
                  disabled={createPropDisable}
                  style={ createPropDisable ? {backgroundColor: '#0000001f', color:'#00000042'}:{backgroundColor: '#004990', color:'#ffffff'}}
                  onClick={() => handleCreateProperties()}
                >
                  {propertyMasterResult.filter(r => !r.asgPropID).length > 0 ? `Create Properties (${propertyMasterResult.filter(r => !r.asgPropID).length})`: 'Create Properties'} 
                </Button>
              </div>
            </div>
            <div className={classes.controlContainerGrid}>
              <div style={{ width: '100%', height: '45%', display: 'flex', flexDirection: 'column' }}>
                <GoogleMap
                  onLoad={onSetMapRef}
                  mapContainerStyle={{ height: `100%` }}
                  zoom={4}
                  options={{
                    mapTypeControlOptions: { style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU },
                    cameraControl: false,
                    zoomControl: true
                  }}
                >
                  {propertyMasterResult.map( col => {
                    if (col.latitude && col.longitude)
                    {
                      return (
                        <Marker
                          key={col.referenceId}
                          position={{ lat: col.latitude, lng: col.longitude }}
                          icon= {currentProp?.referenceId === col.referenceId 
                                  ? {url: YellowMarker, scale: 18,} 
                                  : {url: RedMarker, scale: 14,}} 
                          draggable={true}
                          opacity={1} 
                          title={col.street}
                          onDragEnd={onMarkerDragEnd}
                          onDragStart={onMarkerDragStart}
                          onClick={onMarkerClick}
                          zIndex={currentProp?.referenceId === col.referenceId 
                                  ? 999: 1}
                        />
                      );
                    }
                  })}
                </GoogleMap>
              </div>
              <div id='bulkLocationVerificationGridContainer' style={{ width: '100%', height: '45%', display: 'flex', flexDirection: 'column' }}>
                <DataGrid
                  id='geoJitCreationGrid'
                  ref={gridRef}
                  dataSource={propertyMasterResult.map(row => { return { ...row } })} 
                  keyExpr='referenceId'
                  allowColumnResizing={true}
                  columnResizingMode='widget'
                  showBorders={true}
                  showRowLines={true}
                  showColumnLines={true}
                  height={'100%'}
                  focusedRowEnabled={false}
                  columnAutoWidth={true}
                  highlightChanges={true}
                  onSaved={handleSaveEdit}
                  onFocusedCellChanged ={onFocusedCellChanged}
                  onContextMenuPreparing={handleContextMenu}
                  onEditingStart={onEditingStart}
                  onCellPrepared={cellPrepared}
                >
                  <Editing
                    mode='batch'
                    allowUpdating={true}
                    startEditAction='dblClick'
                  />
                  <KeyboardNavigation
                    editOnKeyPress={true}
                    enterKeyAction='startEdit'
                    enterKeyDirection={'column'}
                  />
                  <ColumnFixing enable={true} />
                  <Sorting mode='none' />
                  <Selection mode={'single'} />
                  <Scrolling rowRenderingMode='virtual' columnRenderingMode='virtual'/>
                  <Paging
                    defaultPageSize={100}
                    enabled={false}
                  />
                  <Pager showInfo={true} />
                  {BulkLocationVerificationGridColumnConfig.map( col => {
                    return (<Column {...col} /> );
                  })}
                </DataGrid>
                <ContextMenu
                  ref={contextMenuRef}
                  onItemClick={handleContextMenuItemClick}
                  itemRender={renderContextMenuItem}
                  onHidden={onHiddenContextMenu}
                  target='#bulkLocationVerificationGridContainer'
                />
              </div>
            </div>
          </DialogContent>
        </div>
      </LoadingOverlayWrapper>
    </Dialog>
  );
};
const styles = theme => ({
  dialogPaper: {
    overflow: 'hidden',
    height: 'calc(100% - 64px)'
  },
  controlContainer: {
    display: 'flex',
    background: '#fff',
    height: '100%'
  },
  controlContainerGrid: {
    background: '#fff',
    height: '94%',
    flexWrap: 'wrap'
  },
  fieldContainer: {
    overflowY: 'auto',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    padding: '4px 0 0 6px'
  },
  buttonDiv: {
    margin: '15px 0',
    marginLeft: '2px'
  },
  loadingOverlayWrapper:{
    minHeight: 0, 
    flexGrow: 1,
    position: 'relative', 
  }
});

const mapDispatchToProps = dispatch => {
  return {
    appNotify: (message, variant, options) => dispatch(appNotify(message, variant, options)),
  }
};
export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(BulkLocationVerificationModal);
